import { Api, Codes } from '../api';
import Login from './login';
import Store from '../store';
export default class {
  constructor() {
    this.refresh();
  }
  getData() {
    return Store.state.isNew;
  }
  setData(value = false) {
    Store.dispatch('setIsNewStudent', value);
  }
  refresh() {
    if (Login.isLogin()) {
      Api.get.getStudentSuccessCardStatus().then(res => {
        if (res.status === Codes.SUCCESS && res.data && res.data.cards) {
          let isNew = res.data.cards.is_new;
          // isNew = false;
          Store.dispatch('setIsNewStudent', isNew);
        }
      });
    }
  }
}
